const clinicCardSetFocus = () => {
    let clinicModal = document.querySelector('.clinic-card');
    if (clinicModal !== null) {
        const closeButton = clinicModal.querySelector('.clinic-card__close-button');
        closeButton.focus();
        const oldTabIndexState = preventTabOutside(clinicModal);
    }
}
export default clinicCardSetFocus;

const preventTabOutside = (modal) => {
    const selector =
        'a[href], area[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]';
    const tabElements = document.querySelectorAll(selector);
    let tabArray = Array.from(tabElements)
    .filter((elem) => !modal.contains(elem))
        .map((elem) => {

            const tabIndex = elem.hasAttribute("tabindex")
                ? elem.getAttribute("tabindex")
                : null;

            elem.setAttribute("tabindex", -1);
            return { elem, tabIndex };
        })
}
// if original one pager functionality is restored use this function on modal close
/*
const reEnableTabOutside = (oldState) => {

    oldState.forEach(({ elem, tabIndex }) => {
        if (tabIndex === null) {
            elem.removeAttribute("tabindex");
        } else {
            elem.setAttribute("tabindex", tabIndex);
        }
    });

}*/
